import { DASHBOARD__MUTATIONS } from "../mutation-types";
import { DASHBOARD__ACTIONS } from '../action-types'
import { DASHBOARD__API } from '@/_helpers/urls'
import http from "@/_helpers/http";

// State
const state = {
    partner_summary: {
        user_name: '',
        user_id: '',
        ib_balance: "0.00",
        totalEarning: "0.00",
        totalWithdraw: "0.00",
        referralAccounts: "0.00",
        referralLink: "",
        latestCommissions: []
    }
};

// Mutations
const mutations = {
    [DASHBOARD__MUTATIONS.PARTNERSUMMARY](state, data) {
        state.partner_summary = data
    },
};

const getters = {};

// Actions
const actions = {
    async [DASHBOARD__ACTIONS.PARTNERSUMMARY]({ commit }) {
        try {
            const { data } = await http().get(DASHBOARD__API.PARTNERSUMMARY);
            commit(DASHBOARD__MUTATIONS.PARTNERSUMMARY, data?.data);
        } catch (error) {
            console.error("Error fetching partner summary:", error);
        }
    }

};

export default {
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
